<div class="fc-meta-bar mt-3 mb-3">
  @if (isInstructionsEnabled) {
    <button class="greyBtn ml-5" type="button" (click)="showInstructions()" title="View FileCapture Instructions">Instructions</button>
  }
  @if (referenceId) {
    <span class="fc-ref-display"><strong>Reference ID: {{ referenceId }}</strong></span>
  }
</div>
